import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(logged-in)/[day]/page.tsx");
